import { css } from "@emotion/react";

import { dimensions } from "@styles";

export const header = css`
  padding: 1rem 0;
`;

export const wrapper = css`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 1rem;
`;

export const buttonWrapper = css`
  display: flex;
  align-items: center;
  justify-self: start;
`;

export const stepperWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  justify-self: center;
`;

export const mobileStepperWrapper = css`
  padding: 0.5rem 1rem;
`;

export const stepperNav = css`
  width: 450px;

  @media (max-width: ${dimensions.tabletMax}) {
    max-width: 100%;
    width: auto;
  }
`;

export const text = css`
  display: flex;
  align-items: center;
  justify-self: end;
`;

export const icon = css`
  margin-right: 0.5rem;
`;
